/*
Sohel 11/02/2022 2699823790 Added Add Event Tactic Form
Sohel 11/02/2022 2699823790 Integrated Save API
Sohel 11/03/2022 2699823790 fixed event Type prepopulate issue
Sohel 11/03/2022 2699823790 event Type Dropdown value changes
Sohel 11/03/2022 2699823790 payload changes
Sohel 11/03/2022 2699823790 Added Code validation and payload Changes
Sohel 11/04/2022 2699823790 change toast message
Sohel 11/04/2022 2699823790 disabled eventType and value
Raghu 11/14/2022 2699823790 Button Alignment Fixes
Sohel 11/18/2022 2699823790 Event Type dropdown Added Valuecode
Sohel 11/23/2022 2699823790 Added Alert Popup
Akhila 11/24/2022 2699823790 rename the field label and Validation message
Akhila 11/25/2022 2699823790 textfield PlaceHolder name change
akhila 11/26/2022 2699823790 rename the field placeHolders
saikrishna 11/29/2022 2699823790 Removed the event type dropdown codes in triggers and triggers group
Lalitha 30/11/2022 2699823790  Added validation on code
Sohel 07/12/2022  2699823790 Trigger validation after touched field
Lalitha 12/09/2022  2699823790 Added reusable backButtonText
Rajesh 12/15/2022 2699823790 added role access
Dilip 12/30/2022 2699823790 renamed labels for code and description
sai krisha 30/12/2022 2699823790 add code description values
dilip 30/12/2022 2699823790 fixed code lowercase issue
dilip 01/04/2023 2699823790 added mode field
Ashraf 01/09/2023 2699823790 fixed role based access
kavyareddy 01/12/2023 2699823790 Added the Repository fields
kavyareddy 01/13/2023 2699823790 Fixed reset issue in eventTriggers
Ravi 02/01/2023 2699823790 rename Enter one or more phases to phase
Ravi 02/20/2023 2699823790 fixed validation issue in code
Raghu 02/22/2023 2699823790 added new class for input field and buttons
Raghu 02/27/2023 2699823790 added new class and fixed alignments
Raghu 03/01/2023 2699823790 fixed alignments
Sohel 03/03/2023 2699823790 Added Event Trigger validate popup
Sohel 03/03/2023 2699823790 removed console
sohel 03/06/2023 2699823790 Added validation message for existing value
Sohel 03/16/2023 2699823790 Fixed validation issue
Sohel 03/27/2023 2699823790 payload changes
Dilip 03/28/2023 2699823790 Fixed status prepopulate issue
Phaneendra 03/28/2023 2699823790 implemented dynamic value on selecting field textfield
Prakash 03/28/2023 2699823790 fixed input filed issue.
Sohel 03/29/2023 2699823790 Added Value Field Validation
Ravi 03/30/2023 2699823790 Added letterCode TextField and updated payload
Sohel 03/30/2023 2699823790 Fixed Letter Code Validation Issue
Sohel 03/30/2023 2699823790 removed value Field
Akhila 04/04/2023 2699823790 Updated the payload
Akhila 04/05/2023 2699823790 table render company name in phase and fix prepopulation issue
Sohel 04/07/2023 2699823790 Client Code and Site Name Prepopulate issue
Prakash 13/04/2023 2699823790 remove margin top
Akhila 05/03/2023 2699823790 bug fixed prepopulation on status, company field and table column copmany data
Sohel 05/08/2023 2699823790 Fixed Status Validation and Payload Changes
Akhila 05/31/2023 2699823790 unsaved changes bug fixed
Akhila 06/14/2023 2699823790 bug fix unsaved changes on save button
Akhila 06/21/2023 2699823790 conditionally disable save and finish button on submission
Sohel 11/01/2023 2699823790 Added Billing Indicator Actions
Sohel 12/05/2023 2699823790 Fixed Phase Change Pre populate Issue
Sohel 12/11/2023 2699823790 Added validation for EventCode and Event Description in EventTriggers
*/
import React, { useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import {
  TextField,
  FormControl,
  Button,
  MenuItem,
  Grid,
  InputAdornment,
  Tooltip,
} from '@material-ui/core';
import { Controller } from 'react-hook-form';
import { ThemeContext } from '../../../../themes/ThemeProvider';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useSelector, useDispatch } from 'react-redux';
import PageLoader from './../../../../components/PageLoader/index';
import { ErrorSnackbar } from './../../../../components/CustomSnackBar/index';
import { SuccessSnackbar } from './../../../../components/CustomSnackBar/index';
import { useEffect } from 'react';
import { getOptions } from './../../../../util/GetDropDownOptions';
import { EVENT_TYPE_TRIGGER } from '../../../../constants/Lookup';
import { FormHelperText } from '@material-ui/core';
import { ArrowBack, Clear, Search } from '@material-ui/icons';
import AttachedTriggersTable from './AttachedTriggersTable';
import {
  fetchBillingIndicator,
  fetchDispositionCodes,
} from '../../../../redux/reducers/EventTactics/EventTactics';
import {
  postEventTriggerGroup,
  resetMessage,
  fetchAllCode,
  resetValidateEventTriggerGroup,
} from '../../../../redux/reducers/EventTriggerGroup';
import { getObject, getValueObject } from './../../../../util/GetDropdownObject';
import SelectTabContextProvider from '../../../../components/SelectTabContext/SelectTabContext';
import { backButtonText } from '../../../../util/Content';
import GuiAutoComplete from '../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../components/FormComponents/GuiTextField';
import { DISPOSITION_CODE, PHASE, GHI_DISPOSITION } from '../../../../constants/Lookup';
import { getDropDownData } from '../../../../redux/reducers/TriggerGroup';
import DialogBox from '../../../../components/DialogBox';
import SearchDataRepositories from '../../GlobalFields/DataRepositories/SearchDataRepositories';
import AttachedTriggerValidatePopup from './AttachedTriggerValidatePopup';
import { fetchAllLetterCode } from '../../../../redux/reducers/LetterMaintainance/NewLetterMaintenance';
import { fetchCorporateDropDownData } from '../../../../redux/reducers/clientMangement/Organizaation';
import { setAlertData } from '../../../../redux/reducers/UnsavedChangesAlertReducer';
import { submissionStart } from '../../../../redux/reducers/CommonActions/commonActions';

export default function AddTrigger({
  setTabValue,
  value,
  handleTabChange,
  handleDirty,
  showAlertRef,
}) {
  const { reusableInputStyles } = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [AttachedTriggersData, setAttachedTriggersData] = useState([]);
  const [deletedClientData, setDeletedClientData] = useState([]);
  const [triggersData, setTriggersData] = useState([]);
  const [eventType, setEventType] = useState('');
  const [codePopover, setCodePopover] = useState(false);
  const [triggerCodesData, setTriggerCodesData] = useState();
  const [open, setOpen] = useState(false);
  const { roleData } = useSelector(({ role }) => role);
  const disable = roleData?.window?.['Event Triggers']?.['ET'];
  const dispatch = useDispatch();
  const [selectedRepoField, setSelectedField] = useState([]);
  const { dispositionDropDown } = useSelector(({ addEventTactic }) => addEventTactic);
  const { dropDownData } = useSelector(({ addTriggerGroup }) => addTriggerGroup);
  const [validate, setValidate] = useState(false);
  const { enabledSubmission } = useSelector(({ commonActions }) => commonActions);
  const {
    successMsg,
    errorMsg,
    isLoading,
    addEventTriggerGroupStatus,
    eventTriggerGroupData,
    allCode,
    validateTriggerGroupStatus,
  } = useSelector(({ eventTriggerGroup }) => eventTriggerGroup);
  const { allLetterCode } = useSelector(({ newLetterMaintenance }) => newLetterMaintenance);
  const { allBillingIndicator } = useSelector(({ addEventTactic }) => addEventTactic);
  const modeOptions = [{ value: 'Test' }, { value: 'Update' }];
  const handleClose = () => {
    setOpen(false);
  };
  // const getObject1 = (option, dropDownData) => {
  //   let options =
  //     dropDownData && dropDownData[GHI_DISPOSITION] ? dropDownData[GHI_DISPOSITION] : [];
  //   let label = {};
  //   // console.log(option1, "option1");
  //   options &&
  //     options.length > 0 &&
  //     options.forEach((item) => {
  //       if (item.value === option) {
  //         console.log(item, "item");
  //         console.log("bil");
  //         label = item;
  //       }
  //     });
  //   console.log(label, "label");
  //   return label;
  // };
  const getObjects = (option, options) => {
    let label = {};
    options &&
      options.length > 0 &&
      options?.forEach((item) => {
        if (
          item?.value === option ||
          item?.key === option ||
          item?.letterCode === option ||
          item?.billingIndicatorNumber?.toString() === option
        ) {
          label = item;
        }
      });
    return label;
  };

  const initialValues = {
    code: eventTriggerGroupData?.groupCode ? eventTriggerGroupData?.groupCode : '',
    description:
      eventTriggerGroupData && eventTriggerGroupData?.groupDescription
        ? eventTriggerGroupData?.groupDescription
        : '',
    eventType:
      eventTriggerGroupData && eventTriggerGroupData?.event
        ? getObject(eventTriggerGroupData?.event, EVENT_TYPE_TRIGGER, dispositionDropDown)
        : '',
    fieldValue:
      eventTriggerGroupData?.fieldValue &&
      !['LTRSENT', 'LTRREQ', 'ALTRDSP', 'ALTRPHSE']?.includes(eventTriggerGroupData?.event)
        ? getValueObject(
          eventTriggerGroupData?.fieldValue.toString(),
          GHI_DISPOSITION,
          dispositionDropDown,
        )
        : '',
    fieldValue1:
      eventTriggerGroupData && eventTriggerGroupData?.fieldValue1
        ? eventTriggerGroupData?.fieldValue1
        : '',
    mode: eventTriggerGroupData?.mode ? getObjects(eventTriggerGroupData?.mode, modeOptions) : '',

    letterCode:
      eventTriggerGroupData?.fieldValue &&
      ['LTRSENT', 'LTRREQ']?.includes(eventTriggerGroupData?.event)
        ? getObjects(eventTriggerGroupData?.fieldValue, allLetterCode)
        : '',
    billingIndicator:
      eventTriggerGroupData?.fieldValue &&
      ['ADDBLIND', 'REMBLIND']?.includes(eventTriggerGroupData?.event)
        ? getObjects(eventTriggerGroupData?.fieldValue, allBillingIndicator)
        : '',
  };
  if (eventTriggerGroupData?.event === 'ALTRDSP') {
    initialValues.fieldValue =
      eventTriggerGroupData && eventTriggerGroupData?.fieldValue
        ? getObject(eventTriggerGroupData?.fieldValue, DISPOSITION_CODE, dispositionDropDown)
        : '';
  }
  if (eventTriggerGroupData?.event === 'ALTRPHSE') {
    initialValues.fieldValue =
      eventTriggerGroupData && eventTriggerGroupData?.fieldValue
        ? getObject(eventTriggerGroupData?.fieldValue, PHASE, dropDownData)
        : '';
  }
  const { setSaveTab } = useContext(SelectTabContextProvider);
  const checkGroupCodeExist = (value) => {
    if (allCode && allCode?.length > 0 && value) {
      const ar = [];
      allCode?.filter((i) => {
        if (
          i?.groupCode?.toUpperCase()?.trim() === value?.toUpperCase()?.trim() &&
          i?.isActive === 'Y'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const checkGroupCodeAlreadyExist = (value) => {
    if (allCode && allCode?.length > 0 && value) {
      const ar = [];
      allCode?.filter((i) => {
        if (
          i?.groupCode?.toUpperCase()?.trim() === value?.toUpperCase()?.trim() &&
          i?.isActive === 'N'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const validationSchema = Yup.object().shape({
    code: eventTriggerGroupData?.groupCode
      ? null
      : Yup.string()
        .required('Event Trigger Name is required')
        .test(
          'groupCode',
          'Event Trigger Name already exist',
          (value) => !checkGroupCodeExist(value),
        )
        .test(
          'groupCode',
          'Event Trigger Name has already been used in the past',
          (value) => !checkGroupCodeAlreadyExist(value),
        ),
    description: Yup.string().required('Event Trigger Description is required'),
    eventType: Yup.mixed().test('eventType', 'Event Type is required', (value) => {
      if (!value?.valueCode) {
        return false;
      } else {
        return true;
      }
    }),
    fieldValue: Yup.mixed().test(
      'fieldValue',
      'Field is required',
      function (value, context, commit) {
        const { parent } = context;
        if (!value?.value && ['ALTRPHSE', 'ALTRPHSE']?.includes(parent?.eventType?.valueCode)) {
          return false;
        }
        if (!value?.valueCode && ['ALTRDSP']?.includes(parent?.eventType?.valueCode)) {
          return false;
        } else {
          return true;
        }
      },
    ),
    fieldValue1: Yup.string().test('fieldValue1', 'Fields is required', function (value, context) {
      const { parent } = context;
      if (parent?.eventType?.valueCode === 'ALTRDBUDW' && selectedRepoField?.length === 0) {
        return false;
      } else {
        return true;
      }
    }),

    mode: Yup.mixed().test('mode', 'Mode is required', (value) => {
      if (!value?.value) {
        return false;
      } else {
        return true;
      }
    }),
    letterCode: Yup.mixed().test('letterCode', 'Letter Code is required', (value, ctx) => {
      if (['LTRSENT', 'LTRREQ']?.includes(ctx.parent?.eventType?.valueCode) && !value?.letterCode) {
        return false;
      } else {
        return true;
      }
    }),
    billingIndicator: Yup.mixed().test(
      'billingIndicator',
      'Billing Indicator is required',
      (value, ctx) => {
        if (
          ['ADDBLIND', 'REMBLIND']?.includes(ctx.parent?.eventType?.valueCode) &&
          !value?.billingIndicatorNumber
        ) {
          return false;
        } else {
          return true;
        }
      },
    ),
  });
  const handleValidationClose = () => {
    setValidate(false);
    dispatch(resetValidateEventTriggerGroup());
  };
  const {
    handleSubmit,
    control,
    reset,
    formState: { isDirty },
    errors,
    setValue,
    getValues,
    handleBlur,
  } = useForm({
    mode: 'all',
    defaultValues: initialValues,
    resolver: yupResolver(validationSchema),
  });
  useEffect(() => {
    if (isDirty) {
      handleDirty(isDirty);
    }
  }, [isDirty]);
  useEffect(() => {
    reset(initialValues);
  }, [allBillingIndicator]);
  useEffect(() => {
    reset(initialValues);
    setEventType(eventTriggerGroupData?.event);
    if (eventTriggerGroupData?.eventTriggerGroupTriggerResponseList?.length > 0) {
      const data = eventTriggerGroupData?.eventTriggerGroupTriggerResponseList?.map((i) => {
        const triggerCode = i?.triggerCode;
        const eventTactic = [];
        eventTactic?.push({ code: triggerCode });
        return {
          code: i?.groupCode || '',
          type: i?.eventType || '',
          triggerId: i?.triggerId ? i?.triggerId : 0,
          // i?.isAgencyTrigger === "Y"
          //   ? "Revone Company"
          //   : i?.isAgencyTrigger === "N"
          //   ? "Department"
          //   : "",
          seqNo: i?.seqNo || '',
          correspondingClients: i?.toContinue || '',
          id: i?.id,
          eventTactic: eventTactic,
          clientCode: i?.clientCode || '',
          corporateName: i?.corporate || '',
          siteName: i?.site || '',
          phase: i?.company || null,
        };
      });
      setTriggersData(data);
      setAttachedTriggersData(data);
    }
  }, [eventTriggerGroupData]);
  useEffect(() => {
    if (successMsg || errorMsg) {
      setTimeout(() => {
        dispatch(resetMessage());
      }, 2500);
    }
  }, [successMsg, errorMsg]);
  useEffect(() => {
    if (addEventTriggerGroupStatus === 200) {
      setTimeout(() => {
        setTabValue(0);
      }, 2000);
    }
  }, [addEventTriggerGroupStatus, successMsg]);
  useEffect(() => {
    if (validateTriggerGroupStatus === 400) {
      setValidate(true);
    } else {
      setValidate(false);
    }
  }, [validateTriggerGroupStatus]);
  useEffect(() => {
    dispatch(getDropDownData());
    dispatch(fetchAllLetterCode());
    dispatch(fetchCorporateDropDownData());
    dispatch(fetchBillingIndicator());
  }, []);

  const getObjectPhase = (typeCode) => {
    let label = [];

    label = dropDownData && dropDownData[typeCode] ? dropDownData[typeCode] : [];

    return label;
  };

  useEffect(() => {
    if (eventTriggerGroupData?.event === 'ALTRDBUDW') {
      const field = [];
      const fieldData = {
        fieldName: eventTriggerGroupData?.fieldValue
          ? eventTriggerGroupData?.fieldValue?.split('.')?.pop()
          : '',
        repositoryName: eventTriggerGroupData?.fieldValue
          ? eventTriggerGroupData?.fieldValue?.split('.')?.shift()
          : '',
      };
      field?.push(fieldData);
      setSelectedField(field);
    }
  }, [eventTriggerGroupData]);

  const onSubmit = (values) => {
    if (values) {
      dispatch(submissionStart());
      const attachedEvenTriggerGroup =
        AttachedTriggersData?.length > 0
          ? AttachedTriggersData?.map((item) => {
            return {
              groupCode: values?.code ? values?.code : '',
              id: item?.id ? item?.id : 0,
              triggerId: item?.triggerId ? item?.triggerId : item?.eventTactic[0]?.id,
              isAgencyTrigger: item?.correspondingClients || '',
              seqNo: item?.seqNo ? item?.seqNo : '',
              toContinue: item?.correspondingClients ? item?.correspondingClients : '',
              triggerCode: item?.eventTactic?.length > 0 ? item?.eventTactic[0]?.code : '',
              clientCode: item?.clientCode ? item?.clientCode : '',
              corporate: item?.corporateName || '',
              site: item?.siteName || '',
              company: item?.phase ? item?.phase : null,
              eventType: item?.type ? item?.type : '',
            };
          })
          : [];
      const data = {
        deleteByIds: deletedClientData?.length > 0 ? deletedClientData : [0],
        event: values?.eventType?.valueCode ? values?.eventType?.valueCode : '',
        eventTriggersList: attachedEvenTriggerGroup,
        fieldValue:
          values?.eventType?.valueCode === 'ALTRDBUDW' && selectedRepoField?.length > 0
            ? selectedRepoField[0]?.repositoryName + '.' + selectedRepoField[0]?.fieldName
            : ['LTRSENT', 'LTRREQ']?.includes(values?.eventType?.valueCode)
              ? values?.letterCode?.letterCode
              : ['LTRSENT', 'LTRREQ']?.includes(values?.eventType?.valueCode) &&
              values?.fieldValue?.valueCode
                ? values?.fieldValue?.valueCode
                : ['ALTRDSP', 'ALTRPHSE']?.includes(values?.eventType?.valueCode)
                  ? values?.fieldValue?.valueCode
                  : ['ADDBLIND', 'REMBLIND']?.includes(values?.eventType?.valueCode)
                    ? values?.billingIndicator?.billingIndicatorNumber
                    : values?.fieldValue?.value
                      ? values?.fieldValue?.value
                      : '',
        fieldValue1: '',
        groupCode: values?.code ? values?.code : '',
        groupDescription: values?.description ? values?.description : '',
        groupId: eventTriggerGroupData?.groupId ? eventTriggerGroupData?.groupId : 0,
        mode: values?.mode?.value ? values?.mode?.value : '',
      };
      dispatch(postEventTriggerGroup(data));
      handleDirty(false, 'fixed');
    }
  };
  const getTriggerCodesData = () => {
    if (allCode && allCode?.length > 0) {
      return allCode?.filter(
        (i) =>
          String(i?.groupCode?.toUpperCase())?.startsWith(triggerCodesData?.toUpperCase()) &&
          i?.isActive === 'Y',
      );
    } else {
      return [];
    }
  };
  useEffect(() => {
    dispatch(fetchDispositionCodes());
    dispatch(fetchAllCode());
    setSaveTab(false);
  }, []);
  window.onclick = function () {
    setCodePopover(false);
  };
  return (
    <>
      <DialogBox
        open={validate}
        dialogClose={handleValidationClose}
        title="Warning !"
        maxWidth="sm"
      >
        <AttachedTriggerValidatePopup handleValidationClose={handleValidationClose} />
      </DialogBox>
      <div>
        <div className="new-standard-textfields button-table-spacing-mb justify-content-start">
          <Button
            variant="outlined"
            type="button"
            className={`search-btn mx-1`}
            onClick={() => {
              if (showAlertRef.current) {
                // handleTabChange("e", 0);
                dispatch(
                  setAlertData({
                    showAlert: showAlertRef.current,
                    alertCallback: () => {
                      setTabValue(0);
                    },
                  }),
                );
              } else {
                setTabValue(0);
              }
            }}
          >
            <ArrowBack className="mr-2" />
            {backButtonText}
          </Button>
        </div>
        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <div className="form-row  new-standard-textfields">
            <div className="col-sm-6 col-md-4 col-lg-4 form-group account-guarantor">
              <FormControl variant="outlined" fullWidth>
                <Controller
                  render={({ value, onChange, onBlur }) => (
                    <TextField
                      className={`${classes.labelName}`}
                      placeholder="Enter Event Trigger Name"
                      margin="dense"
                      name="code"
                      variant="outlined"
                      label="Event Trigger Name"
                      value={value}
                      onBlur={onBlur}
                      inputProps={{ maxLength: 25 }}
                      disabled={Boolean(eventTriggerGroupData?.groupCode)}
                      onChange={(e) => {
                        setValue('code', e.target.value);
                        if (e.target.value) {
                          setCodePopover(true);
                          setTriggerCodesData(e.target.value);
                        } else if (e.target.value === '') {
                          setCodePopover(false);
                        }
                      }}
                      error={Boolean(errors.code?.message)}
                      required
                      // InputLabelProps={{
                      //   shrink: true,
                      // }}
                      fullWidth
                    />
                  )}
                  control={control}
                  name="code"
                />
              </FormControl>
              <FormHelperText variant="outlined" style={{ position: 'relative' }}>
                {errors.code?.message ? errors.code.message : ''}
              </FormHelperText>
              <div className="windowcode-popover Add-trigger-group-popover">
                {codePopover &&
                  getTriggerCodesData()?.map((data, i) => (
                    <MenuItem key={i}>{data?.groupCode?.replace(/ /g, '\u00a0')}</MenuItem>
                  ))}
              </div>
            </div>

            <div className="col-sm-6 col-md-4 col-lg-4 form-group account-guarantor">
              <FormControl variant="outlined" fullWidth>
                <Controller
                  render={({ value, onChange, onBlur }) => (
                    <TextField
                      className={`${classes.labelName}`}
                      placeholder="Enter Event Trigger Description"
                      margin="dense"
                      name="description"
                      variant="outlined"
                      label="Event Trigger Description"
                      value={value}
                      onChange={onChange}
                      onBlur={onBlur}
                      error={Boolean(errors?.description?.message)}
                      required
                      inputProps={{ maxLength: 100 }}
                      // InputLabelProps={{
                      //   shrink: true,
                      // }}
                      fullWidth
                    />
                  )}
                  control={control}
                  name="description"
                />
              </FormControl>
              <FormHelperText variant="outlined">
                {errors.description?.message ? errors.description.message : ''}
              </FormHelperText>
            </div>

            <div className="col-sm-6 col-md-4 col-lg-4 form-group account-guarantor">
              <FormControl margin="dense" variant="outlined" fullWidth>
                <Controller
                  render={(props) => (
                    <GuiAutoComplete
                      {...props}
                      classes={{
                        popper: classes.popper,
                        option: classes.option,
                      }}
                      id="eventType"
                      size="small"
                      autoHighlight
                      disabled={Boolean(eventTriggerGroupData?.event)}
                      options={getOptions(EVENT_TYPE_TRIGGER, dispositionDropDown)}
                      getOptionDisabled={(option) => option.valueCode === 'none'}
                      getOptionLabel={(option) => {
                        return option && option.value
                          ? option.valueCode === null
                            ? option.value
                            : option.value
                          : '';
                      }}
                      renderInput={(params) => (
                        <GuiTextField
                          className={`${classes.labelName}`}
                          {...params}
                          variant="outlined"
                          fullWidth
                          label="Event Type"
                          name="eventType"
                          required
                          // InputLabelProps={{
                          //   shrink: true,
                          // }}
                          error={Boolean(errors?.eventType?.message)}
                          placeholder="Select Event Type"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: 'off',
                          }}
                        />
                      )}
                      onChange={(_, data) => {
                        props.onChange(data);
                        setEventType(data?.valueCode);
                        setValue('fieldValue1', '');
                        setValue('billingIndicator', '');
                        setSelectedField([]);
                      }}
                    />
                  )}
                  name="eventType"
                  control={control}
                />
              </FormControl>
              <FormHelperText variant="outlined">
                {errors.eventType?.message ? errors.eventType.message : ''}
              </FormHelperText>
            </div>

            {eventType === 'ALTRDSP' && (
              <Grid item xs={4} className={`form-group col-sm-3 `}>
                <FormControl margin="dense" variant="outlined" fullWidth>
                  <Controller
                    render={(props) => (
                      <GuiAutoComplete
                        {...props}
                        classes={{
                          option: classes.option,
                        }}
                        id="fieldValue"
                        size="small"
                        autoHighlight
                        options={getOptions(DISPOSITION_CODE, dispositionDropDown)}
                        getOptionLabel={(option) => {
                          return option && option.value
                            ? option.valueCode === null
                              ? option.value
                              : option.valueCode + ' - ' + option.value
                            : '';
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              {...params}
                              variant="outlined"
                              margin="dense"
                              required
                              onBlur={handleBlur}
                              error={Boolean(errors?.fieldValue?.message)}
                              InputLabelProps={{ shrink: true }}
                              label={'Status'}
                              placeholder={`Select Status`}
                              className={`${classes.labelName}`}
                            />
                          </div>
                        )}
                        onChange={(_, data) => {
                          props.onChange(data);
                        }}
                      />
                    )}
                    name="fieldValue"
                    control={control}
                  />
                </FormControl>
                <FormHelperText>
                  {errors.fieldValue?.message ? 'Status is required' : ''}
                </FormHelperText>
              </Grid>
            )}

            {eventType === 'ALTRPHSE' && (
              <Grid item xs={4} className={`form-group col-sm-3 `}>
                <FormControl margin="dense" variant="outlined" fullWidth>
                  <Controller
                    render={(props) => (
                      <GuiAutoComplete
                        {...props}
                        classes={{
                          option: classes.option,
                        }}
                        id="fieldValue"
                        size="small"
                        autoHighlight
                        options={getObjectPhase(PHASE)}
                        getOptionLabel={(option) => {
                          return option && option.value
                            ? option.valueCode === null
                              ? option.value
                              : option.valueCode + ' - ' + option.value
                            : '';
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              {...params}
                              variant="outlined"
                              margin="dense"
                              onBlur={handleBlur}
                              required
                              error={Boolean(errors?.fieldValue?.message)}
                              // InputLabelProps={{ shrink: true }}
                              label={'Phase'}
                              placeholder={'Select Phase'}
                              className={`${classes.labelName}`}
                            />
                          </div>
                        )}
                        onChange={(_, data) => {
                          props.onChange(data);
                        }}
                      />
                    )}
                    name="fieldValue"
                    control={control}
                  />
                </FormControl>
                <FormHelperText>
                  {errors.fieldValue?.message ? 'Phase is required' : ''}
                </FormHelperText>
              </Grid>
            )}
            {(eventType === 'LTRSENT' || eventType === 'LTRREQ') && (
              <Grid item xs={4} className={`form-group col-sm-3 `}>
                <FormControl margin="dense" variant="outlined" fullWidth>
                  <Controller
                    render={(props) => (
                      <GuiAutoComplete
                        {...props}
                        classes={{
                          option: classes.option,
                        }}
                        id="letterCode"
                        size="small"
                        autoHighlight
                        options={allLetterCode || []}
                        getOptionLabel={(option) => {
                          return option && option.letterDescription
                            ? option.letterCode === null
                              ? option.letterDescription
                              : option.letterCode + ' - ' + option.letterDescription
                            : '';
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              {...params}
                              variant="outlined"
                              margin="dense"
                              onBlur={handleBlur}
                              required
                              error={Boolean(errors?.letterCode?.message)}
                              // InputLabelProps={{ shrink: true }}
                              label={'Letter Code'}
                              placeholder={'Select Letter Code'}
                              className={`${classes.labelName}`}
                            />
                          </div>
                        )}
                        onChange={(_, data) => {
                          props.onChange(data);
                        }}
                      />
                    )}
                    name="letterCode"
                    control={control}
                  />
                </FormControl>
                <FormHelperText>
                  {errors.letterCode?.message ? errors.letterCode.message : ''}
                </FormHelperText>
              </Grid>
            )}

            {eventType === 'ALTRDBUDW' && (
              <Grid item xs={4} className="form-group account-guarantor">
                <FormControl margin="dense" variant="outlined" fullWidth>
                  <Controller
                    render={(props) => (
                      <TextField
                        {...props}
                        margin="dense"
                        className={`${classes.labelName}`}
                        variant="outlined"
                        placeholder={`Select Field`}
                        label="Fields"
                        // InputLabelProps={{
                        //   shrink: true,
                        // }}
                        onChange={(e) => {
                          props.onChange(e.target.value);
                        }}
                        fullWidth
                        error={Boolean(errors?.fieldValue1?.message)}
                        handleBlur={handleBlur}
                        disabled
                        value={
                          selectedRepoField?.length > 0
                            ? selectedRepoField[0]?.repositoryName +
                              '.' +
                              selectedRepoField[0]?.fieldName
                            : ''
                        }
                        required
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <Tooltip title={'Search'}>
                                <Search
                                  className={` ${classes.iconSearch}`}
                                  onClick={() => {
                                    setOpen(true);
                                  }}
                                  size="sm"
                                />
                              </Tooltip>
                              <Tooltip title={'Clear'}>
                                <Clear
                                  className={` ${classes.iconSearch}`}
                                  onClick={(e) => {
                                    setSelectedField([]);
                                  }}
                                />
                              </Tooltip>
                            </InputAdornment>
                          ),
                        }}
                      />
                    )}
                    control={control}
                    name="fieldValue1"
                  />
                </FormControl>
                <FormHelperText style={{ color: 'red' }}>
                  {selectedRepoField?.length > 0 ? null : errors?.fieldValue1?.message}
                </FormHelperText>
              </Grid>
            )}
            {['ADDBLIND', 'REMBLIND']?.includes(eventType) && (
              <div className="col-sm-6 col-md-4 col-lg-4 form-group">
                <FormControl margin="dense" variant="outlined" fullWidth>
                  <Controller
                    render={(props) => (
                      <GuiAutoComplete
                        {...props}
                        classes={{
                          popper: classes.popper,
                          option: classes.option,
                        }}
                        id="billingIndicator"
                        size="small"
                        autoHighlight
                        options={allBillingIndicator.length > 0 ? allBillingIndicator : []}
                        getOptionLabel={(option) => {
                          return option && option?.billingIndicatorNumber
                            ? option?.billingIndicatorNumber + ' - ' + option?.billingIndicatorName
                            : '';
                        }}
                        renderInput={(params) => (
                          <GuiTextField
                            className={`${classes.labelName}`}
                            {...params}
                            variant="outlined"
                            fullWidth
                            label="Billing Indicator"
                            name="billingIndicator"
                            required
                            placeholder="Select Billing Indicator"
                            error={Boolean(errors?.billingIndicator?.message)}
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: 'off',
                            }}
                          />
                        )}
                        onChange={(e, value) => {
                          setValue('billingIndicator', value);
                        }}
                      />
                    )}
                    name="billingIndicator"
                    control={control}
                  />
                </FormControl>
                <FormHelperText variant="outlined">
                  {errors?.billingIndicator?.message ? errors?.billingIndicator?.message : ''}
                </FormHelperText>
              </div>
            )}
            <div className="col-sm-6 col-md-4 col-lg-4 form-group">
              <FormControl margin="dense" variant="outlined" fullWidth>
                <Controller
                  render={(props) => (
                    <GuiAutoComplete
                      {...props}
                      classes={{
                        popper: classes.popper,
                        option: classes.option,
                      }}
                      id="mode"
                      size="small"
                      autoHighlight
                      options={modeOptions}
                      getOptionLabel={(option) => {
                        return option && option.value;
                      }}
                      renderInput={(params) => (
                        <GuiTextField
                          className={`${classes.labelName}`}
                          {...params}
                          variant="outlined"
                          fullWidth
                          label="Mode"
                          name="mode"
                          required
                          // InputLabelProps={{
                          //   shrink: true,
                          // }}
                          placeholder="Select Mode"
                          error={Boolean(errors?.mode?.message)}
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: 'off',
                          }}
                        />
                      )}
                      onChange={(e, value) => {
                        setValue('mode', value);
                      }}
                    />
                  )}
                  name="mode"
                  control={control}
                />
              </FormControl>
              <FormHelperText variant="outlined">
                {errors.mode?.message ? errors.mode.message : ''}
              </FormHelperText>
            </div>
          </div>
          <div className={`border-rounded`}>
            <AttachedTriggersTable
              setAttachedTriggersData={setAttachedTriggersData}
              AttachedTriggersData={AttachedTriggersData}
              deletedClientData={deletedClientData}
              setDeletedClientData={setDeletedClientData}
              eventType={eventType}
              editExisting={eventTriggerGroupData?.groupCode}
              eventCode={getValues()?.code || eventTriggerGroupData?.groupCode}
              eventDescription={getValues()?.description || eventTriggerGroupData?.groupDescription}
              handleDirty={handleDirty}
            />
          </div>
          <DialogBox
            hideBackdrop={true}
            open={open}
            dialogClose={handleClose}
            title="Search Fields"
            maxWidth="xl"
          >
            <SearchDataRepositories
              eventTrigger={true}
              isReports={true}
              mapFields={true}
              selectedRepoField={selectedRepoField}
              setSelectedField={setSelectedField}
              selectedField={getValues('fieldValue')}
              handleSelectTriggerField={(value) => {
                console.log(value);
              }}
              handleClose={handleClose}
            />
          </DialogBox>
          <div className="new-standard-textfields d-flex justify-content-center mt-4 mb-2">
            <Button
              type="button"
              onClick={() => {
                reset(initialValues);
                setAttachedTriggersData(triggersData?.length > 0 ? triggersData : []);
              }}
              variant="outlined"
              className={`reset-btn mx-1 ${classes.buttonRoot}`}
              disabled={eventTriggerGroupData?.groupCode && !disable?.edit}
            >
              Reset
            </Button>
            <Button
              type="submit"
              variant="outlined"
              className={`search-btn mx-1 ${classes.buttonRoot}`}
              disabled={(eventTriggerGroupData?.groupCode && !disable?.edit) || enabledSubmission}
            >
              Save
            </Button>
          </div>
          {/* {setSample(isDirty)} */}
        </form>
      </div>
      {isLoading && <PageLoader />}
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </>
  );
}
